import AsyncRoute from '../components/AsyncContainer/AsyncContainer'

// Misc routes
export const NotFoundPage = AsyncRoute(() =>
  import('../components/Pages/NotFound/NotFound')
)

// Authentication Routes
export const HomePage = AsyncRoute(() =>
  import('../components/Pages/Home/Home')
)

// Template Route

export const Templates = AsyncRoute(() =>
  import('../components/Pages/Templates')
)

// Duplicating templates
export const TemplateDuplicator = AsyncRoute(() =>
  import('../components/Pages/TempDuplicator')
)

// Form creator
export const BlankFormCreator = AsyncRoute(() =>
  import('../components/Pages/BlankFormCreator')
)
